import script from "./AgentForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentForm.vue?vue&type=script&setup=true&lang=js"

import "./AgentForm.vue?vue&type=style&index=0&id=cb5a8f28&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb5a8f28"]])

export default __exports__